export const DEFAULT_PAGE_SIZE = 20;

export const DEFAULT_EXPORT_PAGE_SIZE = 1000;

export default {
  DEFAULT_PAGE_SIZE,
  DEFAULT_EXPORT_PAGE_SIZE,
};
